import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NewBannerContainerService } from './new-banner-container.service';

@Component({
  selector: 'fcp-new-banner-container',
  template: `
    <fcp-new-banner
      [banner]="banner | async"
      (wasClicked)="wasClicked.emit($event)"
      (wasClickedScrollToElement)="wasClickedScrollToElement.emit($event)"
    ></fcp-new-banner>
  `
})
export class NewBannerContainerComponent implements OnInit {
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();
  @Input() private id: string;
  public banner: Observable<any>;

  constructor(
    private newBannerContainerService: NewBannerContainerService
  ) {}

  ngOnInit() {
    this.banner = this.newBannerContainerService.getNewBanners(
      this.id
    );
  }
}
